export default "__VITE_ASSET__dba000c3__"